import React, { useEffect, useState } from "react";
import "./CartSubtitle.css";
import Cart from "../Cart/Cart";
import {
  FinancialData,
  ItemDetailsData,
  PastOrderCustomerData,
  RecommendedItem,
} from "../../../../Utils/DefinitionsInterfaces";
import FormCluster from "../FormCluster/FormCluster";
import {
  doNFOTransactionResponse,
  getPastOrderCustomerData,
} from "../../../../Utils/CheckoutAPIs/CheckoutAPIs";

interface CartSubtitleProps {
  stateDefaultItems: FinancialData[];
  stateCheckoutItems: ItemDetailsData[];
  stateRecommendedItems: RecommendedItem[];
  cbRemoveProduct: (itemId: number) => void;
  cbAddRecommended: (itemId: number) => void;
  cbHandlePaymentClick: (data?: doNFOTransactionResponse) => void;
}

const CartSubtitle = (props: CartSubtitleProps) => {
  const [totalSellingPrice, setTotalSellingPrice] = useState<number>(0);
  const [totalBasePrice, setTotalBasePrice] = useState<number>(0);
  const [customerData, setCustomerData] = useState<PastOrderCustomerData[]>([
    { grade: 0, minutes_ago: 0, name: "", school_name: "" },
  ]);

  useEffect(() => {
    let sumSellingPrice = 0;
    let sumBasePrice = 0;
    for (let i = 0; i < props.stateDefaultItems.length; i++) {
      sumSellingPrice += props.stateDefaultItems[i].selling_price;
      sumBasePrice += props.stateDefaultItems[i].base_price;
    }
    for (let i = 0; i < props.stateCheckoutItems.length; i++) {
      sumSellingPrice += props.stateCheckoutItems[i].selling_price;
      sumBasePrice += props.stateCheckoutItems[i].base_price;
    }
    setTotalBasePrice(sumBasePrice);
    setTotalSellingPrice(sumSellingPrice);
    getPastOrderCustomerData()
      .then((data) => {
        console.log("this is the data", data.data.status === "Success");
        if (data.data.status === "Success") {
          setCustomerData(data.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [
    props.stateDefaultItems,
    props.stateCheckoutItems,
    props.stateRecommendedItems,
  ]);

  return (
    <div className="cart-parent-wrapper">
      <div className="cart-subtitle">
        <FormCluster />
        <div className="outer-container">
          <div className="inner-divider"></div>
        </div>
        <Cart
          stateDefaultItems={props.stateDefaultItems}
          stateCheckoutItems={props.stateCheckoutItems}
          stateRecommendedItems={props.stateRecommendedItems}
          cbRemoveProduct={props.cbRemoveProduct}
          cbAddRecommended={props.cbAddRecommended}
          cbHandlePaymentClick={props.cbHandlePaymentClick}
        />
      </div>
    </div>
  );
};

export default CartSubtitle;
